import { KeysEnum } from '../../../../common/utils/types';
import { modelEntityViewRouteParamKeys, ModelEntityViewRouteParams } from '../types';

export interface PortfolioViewRouteParams extends ModelEntityViewRouteParams {}

export const PortfolioViewRouteParamKeys: KeysEnum<PortfolioViewRouteParams> = {
  ...modelEntityViewRouteParamKeys,
};
